import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Grid, Stack } from '@mui/material';
import { Item, WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

export interface INoDataMsgProps {
  title: string;
  msg: string;
  suggestionsList?: string[];
  listTitle?: string;
}
const defaultSuggestionsList = [
  'Using different keywords.',
  'Using more broad keywords.',
  'Using fewer keywords.',
];
const NoDataMsg = ({
  title,
  msg,
  suggestionsList,
  listTitle = 'Try expanding your search by:',
}: INoDataMsgProps) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Item sx={{ bgcolor: WsColors.Yellow300 }}>
          <Stack direction="row" spacing={1}>
            <Grid item xs={0.4}>
              <InfoOutlinedIcon sx={{ color: WsColors.TertiaryShades800, fontSize: '25px' }} />
            </Grid>
            <Grid item xs={8} textAlign="left">
              <WsTypography bold variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.SENARY}>
                {title}
              </WsTypography>
            </Grid>
            <Grid item xs={4}></Grid>
          </Stack>
          <Grid container>
            <Grid item xs={12}>
              <WsTypography color={WsTypoColors.SENARY} display="inline">
                {msg}
              </WsTypography>
            </Grid>
            {(title === 'No Matches Found' || (suggestionsList && suggestionsList?.length > 0)) && (
              <>
                <Grid item xs={12} mt={2}>
                  <WsTypography color={WsTypoColors.SENARY}>{listTitle}</WsTypography>
                </Grid>
                <Grid item xs={12}>
                  {(suggestionsList ?? defaultSuggestionsList).map((suggestion) => (
                    <WsTypography key={suggestion} color={WsTypoColors.SENARY}>
                      &#x2022; {suggestion}
                    </WsTypography>
                  ))}
                </Grid>
              </>
            )}
          </Grid>
        </Item>
      </Grid>
    </Grid>
  );
};

export default NoDataMsg;
